module.exports = __webpack_public_path__ + "static/media/website.b1ee3124.png";